import React, { useEffect, useState } from 'react';
import OutcomesInvoiceList, { TOutcomeColumn } from '../../../../finances/outcomes/invoices/general/list';
import { DefaultButton, PrimaryButton, Stack } from '@fluentui/react';
import Text from '../../../../typography/text';

interface IVendorOutcomeInvoicesListProps {
    vendorId: string;
    statusFilter?: 'all' | 'paid' | 'unpaid';
    onStatusFilterChange?: (status: 'all' | 'paid' | 'unpaid') => void;
}

const VendorOutcomeInvoicesList: React.FC<IVendorOutcomeInvoicesListProps> = ({
    vendorId,
    statusFilter = 'all',
    onStatusFilterChange
}) => {
    const [status, setStatus] = useState<'all' | 'paid' | 'unpaid'>(statusFilter);

    useEffect(() => {
        if (statusFilter && statusFilter !== status) {
            setStatus(statusFilter);
        }
    }, [statusFilter]);

    const _onSelectStatus = (newStatus: 'all' | 'paid' | 'unpaid') => {
        setStatus(newStatus);
        if (onStatusFilterChange) {
            onStatusFilterChange(newStatus);
        }
    };

    const qs: string[] = [`vendor_id=${vendorId}`];
    if (status === 'unpaid') {
        qs.push('payment_status=unpaid');
    } else if (status === 'paid') {
        qs.push('payment_status=paid');
    }

    const columns: TOutcomeColumn[] = [
        'name',
        'type',
        'details',
        'category',
        'dueDate',
        'amount',
        'status',
        'comments'
    ];

    const filterOptions: { key: 'all' | 'paid' | 'unpaid'; label: string; countColor?: string }[] = [
        { key: 'all', label: 'Semua Invoice' },
        { key: 'unpaid', label: 'Belum Lunas (Unpaid)' },
        { key: 'paid', label: 'Sudah Lunas (Paid)' }
    ];

    return (
        <Stack tokens={{ childrenGap: 14 }}>
            {/* Quick Status Filter Tabs */}
            <Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign="center">
                {filterOptions.map((opt) => {
                    const isActive = status === opt.key;
                    const ButtonComponent = isActive ? PrimaryButton : DefaultButton;
                    return (
                        <ButtonComponent
                            key={opt.key}
                            text={opt.label}
                            onClick={() => _onSelectStatus(opt.key)}
                            styles={{
                                root: {
                                    borderRadius: 6,
                                    height: 32,
                                    fontSize: 12,
                                    fontWeight: isActive ? 600 : 500,
                                    padding: '0 14px',
                                    backgroundColor: isActive ? '#2563eb' : '#f8fafc',
                                    color: isActive ? '#ffffff' : '#475569',
                                    borderColor: isActive ? '#2563eb' : '#e2e8f0',
                                },
                                rootHovered: {
                                    backgroundColor: isActive ? '#1d4ed8' : '#f1f5f9',
                                    color: isActive ? '#ffffff' : '#1e293b',
                                }
                            }}
                        />
                    );
                })}
            </Stack>

            {/* Invoices List */}
            <OutcomesInvoiceList
                qs={qs}
                columns={columns}
                hideCreateButton={true}
                variant="plain"
            />
        </Stack>
    );
};

export default VendorOutcomeInvoicesList;
